<!-- Left Side Windows -->
<ng-container *ngFor="let window of leftWindows(); let i = index">
    <svg:g [attr.transform]="'translate(0, ' + (i * 50 + windowMargin()) + ')'">
        <svg:path
            class="window-left"
            [style.animationDelay]="i * 0.01 + 's'"
            d="M78 201 L32 174 V128 L78 155 V201 Z"
            [attr.fill]="window.isLit ? 'var(--window-lit-bg-1)' : 'var(--window-dark-bg-1)'" />
    </svg:g>
</ng-container>

<!-- Right Side Windows -->
<ng-container *ngFor="let window of rightWindows(); let i = index">
    <svg:g
        class="window-right"
        [style.animationDelay]="i * 0.05 + 's'"
        [attr.mask]="'url(#' + window.maskId + ')'">
        <svg:mask
            [attr.id]="window.maskId"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            [attr.x]="window.maskX"
            [attr.y]="window.maskY"
            [attr.width]="window.maskWidth"
            [attr.height]="window.maskHeight">
            <svg:path
                [attr.d]="window.maskPath"
                fill="white" />
        </svg:mask>
        <g [attr.mask]="'url(#' + window.maskId + ')'">
            <path
                [attr.d]="window.windowRightLitPath"
                [attr.fill]="window.isLit ? 'var(--window-lit-bg-2)' : 'var(--window-dark-bg-2)'" />
            <path
                [attr.d]="window.windowShadePath"
                [attr.fill]="'var(--window-shade-bg-1)'" />
        </g>
    </svg:g>
</ng-container>

